@if (timelineImage()) {
  <div class="tw-block tw-my-5 tw-overflow-x-auto">
    <img [src]="timelineImage()"
         alt="improvement timeline"
         class="tw-h-auto tw-max-w-none" />
  </div>
}
